import { Drawer, Layout } from "antd";
import { GoogleTagManager } from "components/GoogleTagManager/GoogleTagManager";
import { DynamicSideNavigation } from "components/Layouts/BaseLayout/DynamicSideNavigation.tsx";
import { TenantDropdown } from "components/Layouts/TenantLayout/TenantDropdown.tsx";
import { ContentWrapper } from "components/UI/ContentWrapper";
import { headerNavigationAtom } from "components/UI/DynamicHeaderNavigation/atoms/headerNavigationAtom.ts";
import { DynamicHeaderNavigation } from "components/UI/DynamicHeaderNavigation/DynamicHeaderNavigation.tsx";
import { PaldockFooter } from "components/UI/PaldockFooter/PaldockFooter.tsx";
import { FC, PropsWithChildren, useState } from "react";
import { useRecoilValue } from "recoil";

const { Content, Footer, Sider } = Layout;

export const BaseLayout: FC<PropsWithChildren> = ({ children }) => {
    const headerNavigationState = useRecoilValue(headerNavigationAtom);
    const [collapsed, setCollapsed] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    return (
        <>
            <GoogleTagManager />
            <Layout className="min-h-screen">
                <Sider
                    collapsed={collapsed}
                    theme="light"
                    breakpoint="lg"
                    width={264}
                    collapsedWidth={80}
                    className={"p-[4px] hidden lg:block border-r border-gray-200"}
                >
                    <div className={"m-[4px]"}>
                        <TenantDropdown collapsed={collapsed} />
                    </div>
                    <DynamicSideNavigation toggleMenuCollapse={toggleCollapsed} />
                </Sider>

                <Drawer
                    placement="left"
                    open={mobileMenuOpen}
                    onClose={closeMobileMenu}
                    width={264}
                    className="lg:hidden"
                    styles={{
                        body: { padding: 0, backgroundColor: "#fff" },
                        header: { backgroundColor: "#fff", borderBottom: "none" },
                    }}
                    closable={false}
                >
                    <div className="p-1">
                        <TenantDropdown collapsed={false} />
                    </div>
                    <div onClick={closeMobileMenu}>
                        <DynamicSideNavigation toggleMenuCollapse={toggleCollapsed} />
                    </div>
                </Drawer>

                <Layout
                    className={`overflow-y-scroll w-full ${headerNavigationState.isEdit ? "bg-[#EBF5F5]" : "bg-[#F5F5F5]"}`}
                >
                    <DynamicHeaderNavigation onMobileMenuToggle={toggleMobileMenu} />
                    <Content style={{ flex: "1 0 auto" }} className={"mx-1 md:mx-10 my-0"}>
                        <ContentWrapper>{children}</ContentWrapper>
                    </Content>
                    <Footer className="bg-transparent px-4 py-0">
                        <PaldockFooter />
                    </Footer>
                </Layout>
            </Layout>
        </>
    );
};
